import graphql__4f0a9a58d32a4e0ee0e3 from "./__generated__/ContributionForm_contribution.graphql.js";import { useEffect } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import { defineMessages } from "react-intl";
import { Navigate } from "react-router";

import FormDisclaimer from "./FormDisclaimer";
import FormPage from "./FormPage";
import FormComplete from "./FormComplete";
import { isAuthorized, isUnauthorized } from "../Utils/authorizations";
import { useAlert } from "../Alerts/withAlert";
import { useNavigateTo } from "../Routes/RoutesContext";

const ContributionForm = props => {
  const contribution = useFragment(ContributionForm_contribution, props.contribution);
  const { edit } = props;
  const { formHash, currentPage, isDraft, participativeModule } = contribution;
  const { disclaimer, completeMessage } = participativeModule;

  const allowSignedInAnonymousContributions = isAuthorized(
    contribution.authorizations.toggleAnonymousMode
  );

  const { contributionsSubmissionAuthorized } = participativeModule.authorizations;
  const { path: parentPath } = participativeModule.visualization;

  const lastNonModalLocation = useSelector(
    ({ location }) => location.lastNonModalLocation
  );
  const redirectPath = lastNonModalLocation?.pathname || parentPath;
  const showDisclaimer =
    isDraft && !currentPage && (disclaimer || allowSignedInAnonymousContributions);
  const showFormPage = (isDraft || edit) && currentPage;
  const showCompleteMessage = !isDraft && !currentPage && completeMessage;

  const disallowShowingModal =
    (showDisclaimer || showFormPage) &&
    !edit &&
    !showCompleteMessage &&
    isUnauthorized(contributionsSubmissionAuthorized);

  const unauthorizedMessages = participativeModule.authorizations.unauthorizedMessages;
  const alertMessage = unauthorizedMessages.contributionsSubmissionAuthorized;

  const { showAlert } = useAlert();
  const navigateTo = useNavigateTo();

  // If the modal can't be show because the user is not authorized to contribute, we show
  // an alert with the corresponding message and redirect the user to the parent path.
  useEffect(() => {
    if (!disallowShowingModal) return;
    showAlert({
      type: "danger",
      message: alertMessage
    });
    navigateTo(redirectPath);
  }, [alertMessage, disallowShowingModal, navigateTo, redirectPath, showAlert]);

  if (disallowShowingModal) {
    return null;
  } else if (showDisclaimer) {
    return <FormDisclaimer contribution={contribution} />;
  } else if (showFormPage) {
    return (
      <FormPage
        key={currentPage.id}
        formKey={formHash}
        intlMessages={intlMessages}
        contribution={contribution}
        currentPageId={currentPage.id}
        edit={edit}
        redirectPath={redirectPath}
      />
    );
  } else if (showCompleteMessage) {
    return <FormComplete contribution={contribution} />;
  } else {
    return <Navigate to={redirectPath} />;
  }
};

const ContributionForm_contribution = graphql__4f0a9a58d32a4e0ee0e3;

export default ContributionForm;

const intlMessages = defineMessages({
  signInMessage: {
    id: "contribution.form.signInMessage",
    defaultMessage: `
      Merci de vous identifier pour pouvoir valider le dépôt de votre
      contribution.
    `
  },
  successMessage: {
    id: "contribution.form.successMessage",
    defaultMessage: `
      Votre avis a bien été pris en compte. Merci pour votre participation !
    `
  }
});
